module.exports = __webpack_public_path__ + "static/img/4areaA_10.3091a3b.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/animal/4areaA_10.png
// module id = 807
// module chunks = 1